import React from 'react';
import {createRoot} from 'react-dom/client';
import {store} from './app/store';
import reportWebVitals from './reportWebVitals';
import {RouterProvider} from "react-router";
import mainRoutes from "./app/route";
import {Provider} from "react-redux";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import {CssBaseline} from "@mui/material";

const container = document.getElementById('root')!;
const root = createRoot(container);
const theme = createTheme({
    palette: {
        primary: {
            main: '#2B3D4C',
            contrastText: '#fff',

        },
        secondary: {
            main: '#C7CFE8',
            contrastText: '#fff',
        },
        warning: {
            main: '#C30073',
            contrastText: '#fff'
        }
    },
    components: {
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    border: '2px solid #000000',
                    color: 'white'
                }
            },
        },
        MuiInput: {
            styleOverrides: {
                root: {
                    border: '2px solid #000000',
                    color: 'white'
                }
            },
        }
    }
});
root.render(
    <Provider store={store}>
        <ThemeProvider theme={theme}>
            <CssBaseline enableColorScheme/>
            <RouterProvider router={mainRoutes}/>
        </ThemeProvider>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
